document.addEventListener('DOMContentLoaded', () => {
    const imageLinks = document.querySelectorAll('.image-grid-item');
    imageLinks.forEach(element => {
        element.addEventListener('click', () => {
            // window.location.href = element.querySelector('.image-grid-text__link a').href;
        })
    })

})